var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLamp = function SvgLamp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m19 12c0 2.16-.98 4.16-2.67 5.5-.69.54-1.14 1.25-1.28 2.01-.02-.01-.03-.01-.05-.01h-6c-.02 0-.05 0-.07.01-.14-.79-.55-1.48-1.14-1.92-2.18-1.65-3.2-4.35-2.64-7.07.55-2.65 2.7-4.81 5.35-5.36 2.11-.45 4.27.07 5.91 1.4 1.65 1.34 2.59 3.32 2.59 5.44z",
    fill: "#ffc107",
    "data-original": "#ffc107",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m15.05 19.51c-.03.17-.05.34-.05.52v2.22c0 .96-.79 1.75-1.75 1.75h-2.5c-.84 0-1.75-.64-1.75-2.04v-1.77c0-.23-.02-.46-.07-.68.02-.01.05-.01.07-.01h6c.02 0 .03 0 .05.01z",
    fill: "#80a7b9",
    "data-original": "#607d8b",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m14.25 21h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m12 3.457c-.414 0-.75-.336-.75-.75v-1.957c0-.414.336-.75.75-.75s.75.336.75.75v1.957c0 .414-.336.75-.75.75z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m18.571 6.179c-.192 0-.384-.073-.53-.22-.293-.293-.293-.768 0-1.061l1.384-1.384c.293-.293.768-.293 1.061 0s.293.768 0 1.061l-1.384 1.384c-.147.146-.339.22-.531.22z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m23.25 12.75h-1.957c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.957c.414 0 .75.336.75.75s-.336.75-.75.75z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m19.955 20.705c-.192 0-.384-.073-.53-.22l-1.384-1.384c-.293-.293-.293-.768 0-1.061s.768-.293 1.061 0l1.384 1.384c.293.293.293.768 0 1.061-.147.147-.339.22-.531.22z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m4.045 20.705c-.192 0-.384-.073-.53-.22-.293-.293-.293-.768 0-1.061l1.384-1.384c.293-.293.768-.293 1.061 0s.293.768 0 1.061l-1.384 1.384c-.147.147-.339.22-.531.22z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m2.707 12.75h-1.957c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.957c.414 0 .75.336.75.75s-.336.75-.75.75z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m5.429 6.179c-.192 0-.384-.073-.53-.22l-1.384-1.384c-.293-.293-.293-.768 0-1.061s.768-.293 1.061 0l1.384 1.384c.293.293.293.768 0 1.061-.148.146-.339.22-.531.22z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m15.75 12.5c-.414 0-.75-.336-.75-.75 0-1.517-1.233-2.75-2.75-2.75-.414 0-.75-.336-.75-.75s.336-.75.75-.75c2.343 0 4.25 1.907 4.25 4.25 0 .414-.336.75-.75.75z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m13.25 24h-2.5c-.843 0-1.75-.64-1.75-2.044v-1.764c0-1.061-.452-2.035-1.209-2.605-2.185-1.645-3.196-4.351-2.639-7.062.545-2.656 2.694-4.813 5.347-5.368 2.11-.444 4.268.07 5.914 1.408 1.644 1.336 2.587 3.317 2.587 5.435 0 2.158-.975 4.161-2.675 5.498-.842.662-1.325 1.584-1.325 2.529v2.223c0 .965-.785 1.75-1.75 1.75zm-1.264-17.498c-.392 0-.787.041-1.182.123-2.076.434-3.757 2.122-4.184 4.201-.439 2.137.355 4.269 2.072 5.562 1.131.852 1.807 2.274 1.807 3.804v1.764c0 .091.012.544.25.544h2.5c.138 0 .25-.112.25-.25v-2.223c0-1.409.692-2.76 1.898-3.709 1.337-1.05 2.103-2.624 2.103-4.318 0-1.664-.742-3.221-2.034-4.271-.988-.802-2.213-1.227-3.48-1.227z",
    fill: "#4c4c4c",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLamp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lamp.68a4f2c5fd94e9e8934ccd8f6dab8905.svg";